import { memo } from "react";
import PropTypes from "prop-types";
import BadgeList from "app/pages/.shared/ColoredProductBadge/BadgeList";
import FavoriteBadge from "app/pages/.shared/FavoriteBadge/FavoriteBadge";
import UnbeatableOfferTag from "app/pages/.shared/UnbeatableOfferTag/UnbeatableOfferTag";
import { TourBadge } from "app/pages/.shared/TourBadge/TourBadge";
import { PRODUCT_TAG_CODES } from "app/constants";
import "./ProductTopBar.scss";

const ProductTopBar = ({ badges = [], isFavorite, isTour = false, unbeatableOfferTag }) => {
	return (
		<div className="product-top-bar" data-testid="product-top-bar">
			<div className="product-top-bar__badges">
				{badges.length > 0 && <BadgeList badges={badges} />}

				{unbeatableOfferTag && <UnbeatableOfferTag type={unbeatableOfferTag} />}

				{isFavorite && !unbeatableOfferTag && <FavoriteBadge />}

				{isTour && <TourBadge />}
			</div>
		</div>
	);
};

ProductTopBar.propTypes = {
	isFavorite: PropTypes.bool,
	isTour: PropTypes.bool,
	unbeatableOfferTag: PropTypes.oneOf([
		PRODUCT_TAG_CODES.LIMITED_TIME,
		PRODUCT_TAG_CODES.LAST_DAY,
	]),
	badges: PropTypes.array,
};

export default memo(ProductTopBar);
